module.exports = __webpack_public_path__ + "img/mergdata_before_after_2.44ec37c9.png";